var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 52 52",
    strokeWidth: 0,
    fill: "currentColor",
    size: 16,
    "data-testid": "receipt-trip-summary-adults-icon",
    width: 16,
    height: 16,
    style: {
      pointerEvents: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".Icon-user_svg__st0{display:none}.Icon-user_svg__st1{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-user_svg__st2{display:inline}.Icon-user_svg__st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-user_svg__st4{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-user_svg__st5{display:inline;fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-user_svg__st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}.Icon-user_svg__st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-user_svg__st8{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10}.Icon-user_svg__st9{stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-user_svg__st10{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10}.Icon-user_svg__st11{fill:none;stroke:#000000;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10}.Icon-user_svg__st12{stroke:#000000;stroke-width:0.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-user_svg__st13{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-user_svg__st14{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.Icon-user_svg__st15{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1032,4.127}.Icon-user_svg__st16{display:inline;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-user_svg__st17{fill:none}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-user_svg__stroke",
    className: "Icon-user_svg__st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Icon-user_svg__st2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,7c4.4112,0,8,3.5888,8,8s-3.5888,8-8,8s-8-3.5888-8-8S21.5888,7,26,7 M26,5c-5.5229,0-10,4.4772-10,10 s4.4771,10,10,10s10-4.4772,10-10S31.5229,5,26,5L26,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Icon-user_svg__st3",
    d: "M43,46v-7.9028C43,32.6163,37.8941,28,31.8203,28H19.9069C13.8331,28,9,32.6163,9,38.0972V46"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon-user_svg__filled"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 15,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,46c0,0.5527,0.4478,1,1,1h34c0.5522,0,1-0.4473,1-1v-7.9023C44,32.082,38.4224,27,31.8203,27H19.9067 C13.3413,27,8,31.9785,8,38.0977V46z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdult);
export default __webpack_public_path__ + "static/media/adult.eab7f473f37a32f5376e7e355d847a1d.svg";
export { ForwardRef as ReactComponent };